<template>
    <v-container fluid fill-height class="home-hero" id="homecontainer" height="1000px">
      <v-layout justify-center align-center column pa-5>
          <div class="display-1 font-weight-black white--text text-center">LIMOTOUR</div>
          <div class="display-4 font-weight-black white--text text-center mb-3">ABOUT</div>
      </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'AboutBanner',
  data: () => ({
  }),
};
</script>

<style scoped>
.home-hero {
    background: url('../../assets/banners/11.jpg');
    background-size: cover;
    height: 300px !important;
    padding: 0;
}
.font-weight-black {
  text-shadow: 2px 2px 8px black;
}
</style>
